export default "__VITE_PUBLIC_ASSET__db00250d__"